"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntervalObservable = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _isNumeric = require("../util/isNumeric");

var _Observable2 = require("../Observable");

var _async = require("../scheduler/async");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IntervalObservable =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(IntervalObservable, _Observable);

  function IntervalObservable() {
    var _this;

    var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scheduler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _async.async;
    (0, _classCallCheck2.default)(this, IntervalObservable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IntervalObservable).call(this));
    _this.period = period;
    _this.scheduler = scheduler;

    if (!(0, _isNumeric.isNumeric)(period) || period < 0) {
      _this.period = 0;
    }

    if (!scheduler || typeof scheduler.schedule !== 'function') {
      _this.scheduler = _async.async;
    }

    return _this;
  }
  /**
   * Creates an Observable that emits sequential numbers every specified
   * interval of time, on a specified IScheduler.
   *
   * <span class="informal">Emits incremental numbers periodically in time.
   * </span>
   *
   * <img src="./img/interval.png" width="100%">
   *
   * `interval` returns an Observable that emits an infinite sequence of
   * ascending integers, with a constant interval of time of your choosing
   * between those emissions. The first emission is not sent immediately, but
   * only after the first period has passed. By default, this operator uses the
   * `async` IScheduler to provide a notion of time, but you may pass any
   * IScheduler to it.
   *
   * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
   * var numbers = Rx.Observable.interval(1000);
   * numbers.subscribe(x => console.log(x));
   *
   * @see {@link timer}
   * @see {@link delay}
   *
   * @param {number} [period=0] The interval size in milliseconds (by default)
   * or the time unit determined by the scheduler's clock.
   * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
   * the emission of values, and providing a notion of "time".
   * @return {Observable} An Observable that emits a sequential number each time
   * interval.
   * @static true
   * @name interval
   * @owner Observable
   */


  (0, _createClass2.default)(IntervalObservable, [{
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var index = 0;
      var period = this.period;
      var scheduler = this.scheduler;
      subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
        index: index,
        subscriber: subscriber,
        period: period
      }));
    }
  }], [{
    key: "create",
    value: function create() {
      var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var scheduler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _async.async;
      return new IntervalObservable(period, scheduler);
    }
  }, {
    key: "dispatch",
    value: function dispatch(state) {
      var index = state.index,
          subscriber = state.subscriber,
          period = state.period;
      subscriber.next(index);

      if (subscriber.closed) {
        return;
      }

      state.index += 1;
      this.schedule(state, period);
    }
  }]);
  return IntervalObservable;
}(_Observable2.Observable);

exports.IntervalObservable = IntervalObservable;